import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import TenantService from '../../services/tenantService';
import bemify from '../../utils/bemUtils';

/**
 * Represents the Essilor Brazil button tiles component
 * @param {Object} props The component properties.
 */
class ButtonTiles extends Component {
  /**
   * Initializes a new instance of the Map component.
   * @param {Object} props The component properties.
   */
  constructor(props) {
    super(props);

    this.state = {
      tiles: []
    };
    this._tenantService = new TenantService();
  }

  /**
   * Executes when the component has mounted to the DOM.
   */
  async componentDidMount() {
    await this._getTenantUiTiles();
    this._getEnrichedTiles();
  }

  _getTenantUiTiles = async () => {
    try {
      const { tiles } = await this._tenantService.getTenantUIOptions();
      this.setState({ tiles: tiles });
    }
    catch (e) {
      console.log(e);
    }
  }

  _getTileIcon = (type) => {
    const { locatorRootUri } = window.locatorTenancy;
    // NOTE: tile types are subject for change
    switch (type) {
      case 'city':
        return `${locatorRootUri}/assets/icons/essilor_map_pin.png`;
      case 'broken-glasses':
        return `${locatorRootUri}/assets/icons/essilor_broken_glasses.png`;
      case 'optician-selection':
        return `${locatorRootUri}/assets/icons/essilor_glasses.png`;
      default:
        return `${locatorRootUri}/assets/icons/essilor_glasses.png`;
    }
  };

  _getTileImgAlt = (type) => {
    // NOTE: tile types are subject for change
    switch (type) {
      case 'city':
        return 'Map Pin';
      case 'broken-glasses':
        return 'Broken Glasses';
      case 'optician-selection':
        return 'Glasses';
      default:
        return 'Glasses';
    }
  };

  _getEnrichedTiles = () => {
    const enrichedTiles = [];
    const {tiles} = this.state;

    if (tiles?.length > 0) {
      tiles.forEach((tile) => {
        enrichedTiles.push({...tile,
          imgAlt: this._getTileImgAlt(tile.type),
          src: this._getTileIcon(tile.type)
        });
      });
    }

    if (enrichedTiles.length > 0) {
      this.setState(() => ({ tiles: enrichedTiles }));
    }
  };

  render() {
    const { tiles } = this.state;
    const [block, element] = bemify('button_tiles');

    return (
      <div className={block()}>
        {
          tiles.map(tile => 
            <button
              key={`${tile.type}-${tile.name}}`}
              className={element('tile')}
              onClick={() => window.open(tile.url)}
            >
              <img
                alt={tile.imgAlt}
                className={element('icon')}
                src={tile.src} />
              {tile.name}
            </button>
          )
        }
      </div>
    );
  }
}


export default withTranslation()(ButtonTiles);